import styled from 'styled-components';

export const Button = styled.button`
  margin: 10px;
  width: 50px;
  height: 50px;
  background-color: #E9B00D;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TopButton = styled(Button)`
  margin-left: auto;
  margin-bottom: 1em;
`;
